import React from 'react';
import { Category } from '../../types';

export function CategoryBadge({ category }: { category: Category }) {
  return (
    <span
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium"
      style={{
        backgroundColor: `${category.color}22`,
        color: category.color,
        border: `1px solid ${category.color}44`,
      }}
    >
      {category.name}
    </span>
  );
}
